import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import RFSelect from './RFSelect';
import req from 'superagent';
import cfg from 'cfg';

class TeamPicker extends React.PureComponent {
    static defaultProps = {
        name: 'teamId'
    };

    componentDidMount() {
        const { tournamentId } = this.props;
        this.updateTeams(tournamentId);
    }

    componentWillReceiveProps({ tournamentId }) {
        if (this.props.tournamentId !== tournamentId) {
            this.updateTeams(tournamentId);
        }
    }
    state = { teams: [] };
    updateTeams = tournamentId => {
        req
            .get(cfg.apis.ss2 + '/tournaments/' + tournamentId + '/teams')
            .then(({ body }) => {
                this.setState({ teams: body });
            })
            .catch(console.log);
    };

    render() {
        const { teams = [] } = this.state;
        const { name } = this.props;
        return (
            <Field
                name={name}
                ignoreCase
                matchProp={'any'}
                options={teams}
                labelKey={'name'}
                valueKey={'id'}
                placeholder={'Team'}
                component={RFSelect}
            />
        );
    }
}

TeamPicker.propTypes = {
    tournamentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
};

export default TeamPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/pickers/TeamPicker.js
 **/